// Monotone cubic (Fritsch–Carlson) interpolation of percentile vs $/mi through the API's quantile
// knots. Passes through every knot exactly and never overshoots, so the CDF chart shows ML's
// quantiles as sent. Domain is [first knot, last knot].
export function buildQuantileCdf(probs, values) {
  const n = values.length;
  const lo = values[0];
  const hi = values[n - 1];
  if (!(hi > lo)) return { lo, hi, pointMass: true, at: () => 0.5 };

  const h = [];
  const slope = [];
  for (let i = 0; i < n - 1; i++) {
    h.push(values[i + 1] - values[i]);
    slope.push((probs[i + 1] - probs[i]) / h[i]);
  }
  const m = new Array(n);
  m[0] = slope[0];
  m[n - 1] = slope[n - 2];
  for (let i = 1; i < n - 1; i++) {
    if (slope[i - 1] * slope[i] <= 0) {
      m[i] = 0;
    } else {
      const w1 = 2 * h[i] + h[i - 1];
      const w2 = h[i] + 2 * h[i - 1];
      m[i] = (w1 + w2) / (w1 / slope[i - 1] + w2 / slope[i]);
    }
  }
  for (let i = 0; i < n - 1; i++) {
    if (slope[i] === 0) {
      m[i] = 0;
      m[i + 1] = 0;
      continue;
    }
    const a = m[i] / slope[i];
    const b = m[i + 1] / slope[i];
    const r = a * a + b * b;
    if (r > 9) {
      const t = 3 / Math.sqrt(r);
      m[i] = t * a * slope[i];
      m[i + 1] = t * b * slope[i];
    }
  }

  const at = (x) => {
    if (x <= lo) return probs[0];
    if (x >= hi) return probs[n - 1];
    let i = 0;
    while (i < n - 2 && x > values[i + 1]) i++;
    const t = (x - values[i]) / h[i];
    const t2 = t * t;
    const t3 = t2 * t;
    return (
      (2 * t3 - 3 * t2 + 1) * probs[i] + (t3 - 2 * t2 + t) * h[i] * m[i] + (-2 * t3 + 3 * t2) * probs[i + 1] + (t3 - t2) * h[i] * m[i + 1]
    );
  };

  return { lo, hi, pointMass: false, at };
}
